
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf/[book_id]",
      function () {
        return require("private-next-pages/pdf/[book_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdf/[book_id]"])
      });
    }
  